import { Button, Card, Col, Flex, Row, Tabs } from 'antd';
import React from 'react';
import IntlMessage from '../../components/IntlMessage';
import Statistics from './Statistics';
import Route from './Route';
import { useSelector } from 'react-redux';

const Trips = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  let tabs = [
    {
      key: '1',
      label: <IntlMessage id="global.statistics" />,
      children: <Statistics />,
    },
    {
      key: '2',
      label: <IntlMessage id="global.routes" />,
      children: <Route />,
    },
  ];
  if (authUser?.collaborator?.params || authUser?.userOperator?.params) {
    const attribute =
      JSON.parse(authUser?.collaborator?.params || '{}')?.attribute ||
      JSON.parse(authUser?.userOperator?.params || '{}')?.attribute;

    console.log('attributeattributeattributeattribute', attribute);
    if (
      attribute?.includes('passenger_list') &&
      !attribute?.includes('finance')
    ) {
      tabs = tabs.filter((i) => i.key === '2');
    }
  }
  return (
    <Card>
      <Tabs
        defaultActiveKey="1"
        type="line"
        size="large"
        items={tabs}
        centered
        destroyInactiveTabPane={true}
      />
    </Card>
  );
};

export default Trips;
